import { InfoCircle } from "@untitledui/icons";
import { Input } from "@/components/base/input/input";
import { TextArea } from "@/components/base/textarea/textarea";
import { FieldGroup } from "./FieldGroup";
import type { CustomRiskRequestForm } from "./RequestCustomRiskModal";

type Props = {
  form: CustomRiskRequestForm;
  onChange: (patch: Partial<CustomRiskRequestForm>) => void;
  errors: Record<string, string>;
};

export function AboutStep({ form, onChange, errors }: Props) {
  return (
    <div className="flex gap-8">
      <div className="w-48 shrink-0 flex flex-col gap-3">
        <div className="bg-indigo-50 rounded-lg p-2 w-fit">
          <InfoCircle className="size-5 text-indigo-700" />
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-sm font-semibold text-primary">Basic details</p>
          <p className="text-sm text-tertiary">Name and describe the risk you'd like us to detect.</p>
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-5">
        <FieldGroup
          label="Name"
          description="A short label we'll use to identify the risk on your taxonomy."
          required
          error={errors["about.name"]}
        >
          <Input
            aria-label="Name"
            isRequired
            placeholder="e.g. Off-label use"
            value={form.about.name}
            onChange={(v) => onChange({ about: { ...form.about, name: v } })}
            isInvalid={!!errors["about.name"]}
          />
        </FieldGroup>

        <FieldGroup
          label="What should this detect?"
          description="Describe the concept in your own words. Be specific about edge cases."
          required
          error={errors["about.detect"]}
        >
          <TextArea
            aria-label="What should this detect?"
            isRequired
            placeholder="Content that..."
            value={form.about.detect}
            onChange={(v) => onChange({ about: { ...form.about, detect: v } })}
            isInvalid={!!errors["about.detect"]}
            rows={5}
          />
        </FieldGroup>
      </div>
    </div>
  );
}
